var React = require('react');

function Scroll (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\n"),React.createElement("path",{"className":"st0","d":"M254,324.9c-38.6,0-69.9-31.4-69.9-69.9s31.4-69.9,69.9-69.9s69.9,31.4,69.9,69.9S292.6,324.9,254,324.9z\n\t M254,225c-16.5,0-30,13.4-30,30s13.4,30,30,30s30-13.4,30-30S270.5,225,254,225z M360,407l-28.3-28.3L255,455.5l-73.8-73.8L153,410\n\tl102,102L360,407z M360,105L255,0L152,103l28.3,28.3L255,56.5l76.8,76.8L360,105z","key":1})]);
}

Scroll.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 512 512","style":{"enableBackground":"new 0 0 512 512"},"xmlSpace":"preserve"};

module.exports = Scroll;

Scroll.default = Scroll;
